import '@styles/views/csc.less';
import AppBannerPs from '@components/app/appBannerPs';
//import AppAdvantage from '@components/app/appAdvantage';
import AppVisualReview from '@components/app/appVisualReview';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
//import AppBimWindows from '@components/app/appBimWindows';
import AppFooter from '@components/app/appFooter';

const CSD = () => {
  return (
    <div className={'introduce-page'}>
      <AppBannerPs />
      <AppVisualReview />
      {/* <AppBimWindows /> */}
      {/* <AppAdvantage showDesc  style={{ marginTop: '30px' }}/> */}
      {/* <AppDisplayDesc /> */}
      <AppFooter />
    </div>
  );
};

export default CSD;
